import { Component, ViewChild } from '@angular/core';
import {
    NavController,
    ModalController,
    Refresher,
    ToastController,
    PopoverController,
    LoadingController} from 'ionic-angular';

import { AlertMessager } from '../../lib/alertMessager';

import { RodeoService } from '../../services/rodeo.service';
import { Rodeo } from '../../model/rodeo';
import { FilterPage } from '../filter/filter-page';
import { SearchOptions } from '../../model/searchOptions';
import { Subscription } from 'rxjs';
import { StaffPage } from '../staff/staff';
import { DrawSimulation } from './draw-simulation';
import { AccountHelper } from '../../lib/accountHelper';
import { DrawResults } from './draw-results';

@Component({
    selector: 'page-rodeos',
    templateUrl: 'rodeos.html'
})
export class RodeosPage {
    @ViewChild(Refresher) refresher;
    @ViewChild('content') content;

    rodeoMode: string = 'current';

    currentRodeos: Rodeo[] = [];
    upcomingRodeos: Rodeo[] = [];

    searchOptions: SearchOptions = new SearchOptions();
    loadingData: boolean = true;
    
    popoverActive: boolean;

    admin: boolean;
    prompted: boolean;
    subscriptions: Subscription[] = [];

    accountHelper: AccountHelper;

    constructor(public nav: NavController, private rodeoService: RodeoService, private toast: ToastController, private popoverController: PopoverController,
                private alert: AlertMessager, private modalCtrl : ModalController, private loadingControl: LoadingController) 
    {
        this.accountHelper = AccountHelper.instance();
    }

    ionViewDidLoad() {
        this.refresher.state = 'ready';
        this.refresher._top = this.content.contentTop + 'px';
        this.refresher._beginRefresh();

        this.admin = AccountHelper.instance().isNextGenAdmin();
    }

    getEntryCount(rodeo : Rodeo) {
        return rodeo.rodeoEvents.map(x => x.registrations.length).reduce((a, b) => a + b);
    }

    selectRodeo(rodeo: Rodeo) {
        if (this.nav.last()) {
            let addRodeo = data => {
                if (data != null && data != undefined && data.length > 0) {
                    this.search();
                }
            };

            let loading = this.loadingControl.create({
                content: 'Retrieving Rodeo Information...',
            });
    
            loading.present();
            this.rodeoService.getRodeo(rodeo.id)
            .then(data => {
                this.loadingData = false;
                loading.dismiss();
            
                (data as Rodeo).rodeoEvents.forEach((rodeoEvent) => {
                    rodeoEvent.eventType = rodeoEvent.eventType.split(' ').join('');
                });

                this.nav.push(StaffPage, { rodeo: data as Rodeo, callback: addRodeo });
            });
        }
    }

    openSearchFilters() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        
        let popover = this.popoverController.create(FilterPage, {
            searchOptions: this.searchOptions
        }, { cssClass: 'filter-page' });
    
        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                this.searchOptions = data as SearchOptions;
                this.search();
            }
        });
    }

    addRodeo() {
        if (this.nav.last()) {
            let addRodeo = data => {
                if (data != null && data != undefined && data.length > 0) {
                    this.search();
                }
            };

            this.nav.push(StaffPage, { rodeo: new Rodeo(), callback: addRodeo });
        }
    }

    search() {
        if (this.refresher.state != 'refreshing') {
            this.refresher.state = 'ready';
            this.refresher._top = this.content.contentTop + 'px';
            this.refresher._beginRefresh();
        }
        
        this.loadingData = true;

        this.rodeoService.getCurrentRodeos(this.searchOptions)
        .then(data => {
            
            Object.assign(this.currentRodeos, data);
            // console.log('getCurrentRodeos: ', this.currentRodeos);
            this.refresher.complete();
        }, error => { 
            console.log(error); this.alert.showError('Error', 'Unable to retrieve rodeos at this time.') 
            this.refresher.complete();
        });

        this.rodeoService.getUpcomingRodeos(this.searchOptions)
        .then(data => {
            Object.assign(this.upcomingRodeos, data);
            // console.log('upcomingRodeos: ', this.upcomingRodeos);
            this.refresher.complete();
            this.loadingData = false;
        }, error => { 
            console.log(error); this.alert.showError('Error', 'Unable to retrieve entries at this time.') 
            this.loadingData = false;
            this.refresher.complete();
        });
    }

    drawRodeos() {
        if (this.popoverActive)
            return;

        let loader = this.loadingControl.create({
            content: 'Drawing rodeos....'
        });

        loader.present();

        this.popoverActive = true;
        this.rodeoService.drawRodeos(null)
        .then(data => {
            let entryModal = this.modalCtrl.create(DrawResults, { results: data}, { cssClass: 'page-draw-results', enableBackdropDismiss: false });

            entryModal.present();
            entryModal.onDidDismiss((data) =>{
                this.popoverActive = false;
            });
            loader.dismiss();
        }, error => { 
            console.log(error); this.alert.showError('Error', 'Unable to draw rodeos.') 
            loader.dismiss();
        });
    }

    drawSimulation() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        let entryModal = this.modalCtrl.create(DrawSimulation, { }, { cssClass: 'page-draw-simulation', enableBackdropDismiss: false });

        entryModal.present();
        entryModal.onDidDismiss((data) =>{
            this.popoverActive = false;
        });
    }
    
    doRefresh(refresher) {
        this.search();
    }
}


// WEBPACK FOOTER //
// ./src/pages/rodeo/rodeos.ts